import { render, staticRenderFns } from "./SelectedServicePage.vue?vue&type=template&id=785f94f5&"
import script from "./SelectedServicePage.vue?vue&type=script&lang=js&"
export * from "./SelectedServicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports